import React, { useEffect, useRef, useState } from "react";

const expertiseItems = [
  {
    color: "color-1",
    icon: "icon-clipboard",
    title: "Requirements Analysis",
    description:
      "Turn business goals into clear scope, trade-offs, and delivery plans for mobile products.",
  },
  {
    color: "color-2",
    icon: "icon-group",
    title: "Technical Leadership & Mentoring",
    description:
      "Lead SDLC delivery through code reviews, mentoring, and Agile/Scrum practices (PSM I).",
  },
  {
    color: "color-3",
    icon: "icon-flash",
    title: "Performance & Offline Sync",
    description:
      "Offline storage, background sync, and multithreading — ICARUS OPS checklist sync across aviation, data centers, warehouses, and mining; cut from 30+ min to ~8–10.",
  },
  {
    color: "color-4",
    icon: "icon-bulb",
    title: "AI & LLM Integration",
    description:
      "Claude (Anthropic API), LLM-powered features, and MCP workflows in production apps.",
  },
  {
    color: "color-5",
    icon: "icon-credit-card",
    title: "Payments & Integrations",
    description:
      "PayU, Stripe Tap to Pay, APNs/FCM, Twilio, social sign-in, and third-party SDK integrations.",
  },
  {
    color: "color-6",
    icon: "icon-search4",
    title: "Testing & Optimization",
    description:
      "XCTest, automated testing, CI/CD, and performance tuning aligned with ISTQB practices.",
  },
];

const counterStats = [
  { value: 35, suffix: "+", label: "Apps Shipped" },
  { value: 11, suffix: "+", label: "Years Experience" },
  { value: 3, suffix: "", label: "Professional Certifications" },
];

const COUNTER_BG = `${process.env.PUBLIC_URL}/assets/images/counter-bg.webp`;

const Services = () => {
  const counterRef = useRef(null);
  const [showCounterBg, setShowCounterBg] = useState(false);

  useEffect(() => {
    const node = counterRef.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setShowCounterBg(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShowCounterBg(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section
        className="colorlib-services"
        data-section="services"
        id="services"
      >
        <div className="colorlib-narrow-content">
          <div className="row">
            <div
              className="col-md-10 col-md-offset-1 col-md-pull-1 animate-box services-section-header"
              data-animate-effect="fadeInLeft"
            >
              <span className="heading-meta">What I do?</span>
              <h2 className="colorlib-heading">
                Here are some of my expertise
              </h2>
            </div>
          </div>
          <div className="row row-pt-md">
            {expertiseItems.map((item) => (
              <div
                key={item.title}
                className="col-md-4 text-center animate-box"
              >
                <div className={`services ${item.color}`}>
                  <span className="icon">
                    <i className={item.icon} />
                  </span>
                  <div className="desc">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div
        ref={counterRef}
        id="colorlib-counter"
        className="colorlib-counters"
        style={
          showCounterBg
            ? { backgroundImage: `url('${COUNTER_BG}')` }
            : undefined
        }
      >
        <div className="overlay" />
        <div className="colorlib-narrow-content">
          <div className="row">
            {counterStats.map((stat) => (
              <div key={stat.label} className="col-md-4 text-center animate-box">
                <span className="counter-wrap">
                  <span
                    className="colorlib-counter js-counter"
                    data-from={0}
                    data-to={stat.value}
                    data-speed={5000}
                    data-refresh-interval={stat.value}
                  />
                  {stat.suffix ? (
                    <span className="colorlib-counter-suffix">{stat.suffix}</span>
                  ) : null}
                </span>
                <span className="colorlib-counter-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
